// Footer.jsx
// This component creates the footer at the bottom of every page

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Footer.css';

function Footer() {
  // Get translations from language context
  const { t } = useLanguage();

  // Get current route
  const location = useLocation();

  // All pages
  const pages = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/gallery", label: "Gallery" },
    { path: "/contact", label: "Contact" }
  ];

  // Hide current page
  const visiblePages = pages.filter(
    page => page.path !== location.pathname
  );

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Name */}
        <div className="footer-logo">Saaj Fashion Art</div>

        {/* Tagline */}
        <div className="footer-tagline">{t.footer.tagline}</div>

        {/* Social Links */}
        {/* <div className="social-links">
          <a 
            href="mailto:saajfashionart28@gmail.com" 
            title="Email"
            aria-label="Email"
          >
            ✉️
          </a>
          <a 
            href="https://wa.me/919850488855" 
            target="_blank" 
            rel="noopener noreferrer"
            title="WhatsApp"
            aria-label="WhatsApp"
          >
            💬
          </a>
          <a 
            href="tel:+919850488855" 
            title="Call"
            aria-label="Phone"
          >
            📞
          </a>
        </div> */}

        {/* ✅ NEW: Dynamic Page Buttons */}
        <ul className="footer-links nav-links">
          {visiblePages.map(page => (
            <li key={page.path}>
              <Link to={page.path}>{page.label}</Link>
            </li>
          ))}
        </ul>

        {/* Copyright Info */}
        <div className="copyright">
          <p>© 2025 Saaj Fashion Art. {t.footer.copyright}</p>
          <p className="crafted-text">{t.footer.crafted}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

/*
KEY CONCEPTS:

1. SIMPLE COMPONENT:
   - This is a "presentational" component
   - It just displays information, no complex logic

2. DESTRUCTURING:
   - const { t } = useLanguage()
   - This extracts 't' from the object returned by useLanguage()

3. TARGET="_BLANK":
   - Opens links in new tab
   - rel="noopener noreferrer" is for security

4. ARIA LABELS:
   - aria-label helps screen readers for accessibility
   - Important for users with disabilities
*/
